import Card from "components/card";
import DisclosureCard from "components/DisclosureCard";
import { Link } from "react-router-dom";

const SecondCardSx = ({ state }) => {
    const licenseName = {
        channels: "Canali",
        conference_rooms: "Stanze di Conferenze",
        extensions: "Interni",
        faxes: "Fax",
        ivr: "Menu IVR",
        recordings: "Registrazioni chiamate",
        survivors: "Sopravvivenza locale",
        ucs: "UC",
        voicemails: "Caselle Vocali",
        easytomeets: "easytomeets",
        hotel_rooms: "Camere Hotel",
        cc_pro_agents: "Agenti Call Center PRO",
        cc_advanced_stats: "Statistiche avanzate CC",
        support_groups: "Modulo reperibili",
        easy_consoles: "Easy Console",
        smart_hotel_rooms: "Smart Room",
        simultaneous_calls: "Chiamate Simultanee",
    };

    let reduced;
    if (state?.mac_addresses) {
        reduced = Object.keys(state.mac_addresses).reduce((acc, current) => {
            let val = state.mac_addresses[current];
            if (val && val !== "") {
                return acc + "\n\r" + current + ": " + val;
            } else {
                return acc;
            }
        }, "");
    }
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative mb-6 flex items-center justify-between">
                    <div className="flex">
                        <div className="text-2xl font-bold text-gray-800 dark:text-white">
                            Dati tecnici
                        </div>
                    </div>
                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Dati server"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <div className="flex flex-wrap">
                    <div className="flex w-full flex-col gap-2 md:flex-row">
                        <div className="grow">
                            <div className="mb-6 w-1/2">
                                <span className="text-sm font-medium text-gray-600">
                                    Nome:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state?.domain?.name || ""}
                                </span>
                            </div>
                            <div className="mb-6 w-1/2">
                                <span className="text-sm font-medium text-gray-600">
                                    Creato:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state?.domain?.created_at || ""}
                                </span>
                            </div>
                            <div className="mb-6 w-1/2">
                                <span className="text-sm font-medium text-gray-600">
                                    Aggiornato:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state?.domain?.updated_at || ""}
                                </span>
                            </div>
                        </div>

                        <div className="grow">
                            <div className="mb-6 w-1/2">
                                <span className="text-sm font-medium text-gray-600">
                                    Tipo:{" "}
                                </span>
                                <span className="text-sm font-medium text-gray-800">
                                    {state?.server?.type || ""}
                                </span>
                            </div>
                            {state?.server?.type !== "CLOUD" ? (
                                <div className="mb-6 w-1/2">
                                    <span className="text-sm font-medium text-gray-600">
                                        Codice server:{" "}
                                    </span>
                                    <span className="text-sm font-medium text-gray-800">
                                        <Link
                                            to={{
                                                pathname: `/my/server/${
                                                    state?.server?.code || ""
                                                }`,
                                            }}
                                            className="hover:text-blue-500 dark:hover:text-white"
                                        >
                                            {state?.server?.code || ""}
                                        </Link>
                                    </span>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="w-full">
                        <div className="relative overflow-x-auto">
                            <table className="w-full text-left text-sm text-gray-500 rtl:text-right dark:text-gray-400">
                                <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">
                                            Risorsa
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Disponibilità
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Utilizzo
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(state?.domain?.licenses)
                                        ?.length > 0 &&
                                    state?.domain?.licenses ? (
                                        <>
                                            {Object.keys(
                                                state?.domain?.licenses
                                            )?.map((key) => {
                                                let license =
                                                    state?.domain?.licenses[
                                                        key
                                                    ];
                                                return (
                                                    <tr className="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
                                                        <th
                                                            scope="row"
                                                            className="whitespace-nowrap px-6 py-4 font-medium text-gray-900 dark:text-white"
                                                        >
                                                            {key
                                                                ? licenseName[
                                                                      key
                                                                  ]
                                                                    ? licenseName[
                                                                          key
                                                                      ]
                                                                    : key
                                                                : ""}
                                                        </th>
                                                        <td className="px-6 py-4">
                                                            {license?.value ??
                                                                ""}
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            {license?.used ??
                                                                ""}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <tr className="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
                                            <th
                                                colSpan={3}
                                                scope="row"
                                                className="whitespace-nowrap px-6 py-4 font-medium text-gray-900 dark:text-white"
                                            >
                                                Nessun dettaglio presente
                                            </th>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        />
    );
};

export default SecondCardSx;
